import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.role$.pipe(
    map((role) => {
      if (role === 'admin') {
        return true;
      }
      return router.parseUrl('/login');
    }),
  );
};
